import React, { useRef, useState } from 'react';
import { AppMenu, AppMenuProps } from './AppMenu';
import styles from './DotMenu.module.scss';
import Dots from 'assets/icons/dots.svg?react';
import { clsx } from 'clsx';

export type DotMenuProps = Omit<AppMenuProps, 'anchorEl' | 'open'> & {
  dotMenuClassName?: string;
};

export const DotMenu: React.FC<DotMenuProps> = React.memo(
  function DotMenu(props) {
    const menuAnchorRef = useRef<HTMLElement>(null);
    const [isMenuShown, setIsMenuShown] = useState(false);
    return (
      <div>
        <div
          ref={menuAnchorRef as any}
          className={clsx(styles.dotMenu, props.dotMenuClassName)}
          onClick={() => {
            setIsMenuShown(true);
          }}
        >
          <Dots className={styles.dotMenuImage} />
        </div>
        <AppMenu
          {...props}
          anchorEl={menuAnchorRef.current}
          open={isMenuShown}
          onClose={() => {
            setIsMenuShown(false);
          }}
        />
      </div>
    );
  },
);
